/// <reference path="../../libs.ts" />
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IGetSuspendedSubscriptionSettingParams {
  user: string;
}

export interface IGetSuspendedSubscriptionSettingResult extends IResult {
  enabled: boolean;
}
export class GetSuspendedSubscriptionSettingRequest extends Request<IGetSuspendedSubscriptionSettingParams, IResult> {
  constructor(params: IGetSuspendedSubscriptionSettingParams) {
    super('getSuspendedSubscriptionNotificationSetting', params);
  }
}
